const OptGroup = () => null;
OptGroup.isSelectOptGroup = true;
OptGroup.displayName = 'WdSelectOptGroup';
export default OptGroup;
